class Faqs extends HTMLElement {
    constructor() {
        super();
        const toggles = this.querySelectorAll('.js-faq-toggle')
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault()
                const target = this.querySelector(toggle.getAttribute('data-target'))
                toggle.classList.toggle('is-active')
                if (target.style.maxHeight) {
                    target.style.maxHeight = null
                } else {
                    target.style.maxHeight = target.scrollHeight + 'px'
                }
            })
        })

        window.addEventListener('resize', function (event) {
            const targets = this.querySelectorAll('.faq__answer')
            targets.forEach((target) => {
                if (target.style.maxHeight) {
                    target.style.maxHeight = target.scrollHeight + 'px'
                }
            })
        })

    }
}


customElements.define('faqs-blocks', Faqs);